import React from "react";
import dayjs from "dayjs";

// FIXME: are dayjs modules needed here?

export function ActivityDates({ activity, full }) {
  const start = dayjs(activity.start_date);
  const end = dayjs(activity.end_date);
  const startYear = start.format("YYYY");
  const endYear = end.format("YYYY");
  const startMonth = start.format("MMMM");
  const endMonth = end.format("MMMM");
  const startDay = start.format("D");
  const endDay = end.format("D");

  return (
    <div className={full ? "activity-dates-full" : "activity-dates"}>
      {startYear === endYear
        ? startMonth === endMonth
          ? full
            ? startDay === endDay
              ? `${startMonth} ${startDay}, ${startYear}`
              : `${startMonth} ${startDay}-${endDay}, ${startYear}`
            : `${startMonth} ${startYear}`
          : full
          ? `${startMonth} ${startDay} -${endMonth} ${endDay}, ${startYear}`
          : `${startMonth}-${endMonth}, ${startYear}`
        : full
        ? `${startMonth} ${startDay}, ${startYear} -${endMonth} ${endDay}, ${endYear}`
        : `${startYear}-${endYear}`}
    </div>
  );
}

export default ActivityDates;
